export default __webpack_public_path__ + "static/media/tweeter.b6778df4.svg";